import { createStore } from 'vuex'
import articles from './modules/articles'
import news from './modules/news'
import series from './modules/series'
import volumes from './modules/volumes'
import contact from './modules/contact'
import publishers from './modules/publishers'
import statistics from './modules/statistics'
import aboutUs from './modules/about-us'
import sliders from './modules/sliders'

export default createStore({
    modules: {
        articles,
        news,
        series,
        volumes,
        contact,
        publishers,
        statistics,
        aboutUs,
        sliders
    }
})